import {Component, OnInit} from '@angular/core';
import {MenuItemComponent} from "./menu-item/menu-item.component";
import {NgForOf} from "@angular/common";
import {Router} from "@angular/router";

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  imports: [
    MenuItemComponent,
    NgForOf
  ]
})
export class MenuComponent implements OnInit {

  model = [
    {
      label: '',
      items: [
        {label: 'Home',icon: 'pi pi-fw pi-home', routerLink: '/dashboard/stats/user', separator: true},
        {label: 'Bookings', icon: 'pi pi-fw pi-calendar', routerLink: '/dashboard/booking'},
        {label: 'Add Booking', icon: 'pi pi-fw pi-plus', routerLink: '/dashboard/booking/edit', offset: 1},
        {label: 'Recurring Bookings', icon: 'pi pi-fw pi-refresh', routerLink: '/dashboard/recurring-booking', separator: true},

        {label: 'Parents', icon: 'pi pi-fw pi-users', routerLink: '/dashboard/parent'},
        {label: 'Sitters', icon: 'pi pi-fw pi-user', routerLink: '/dashboard/sitter'},
        {label: 'Add Sitter', icon: 'pi pi-fw pi-plus', routerLink: '/dashboard/sitter/edit', offset: 1},
        {label: 'SMS Notifications', icon: 'pi pi-fw pi-send', routerLink: '/dashboard/notification', separator:true},

        {label: 'Promo Codes', icon: 'pi pi-fw pi-tag', routerLink: '/dashboard/promo-code'},
        {label: 'Surge Prices', icon: 'pi pi-fw pi-bolt', routerLink: '/dashboard/surge'},
        {label: 'Price Rules', icon: 'pi pi-fw pi-sliders-h', routerLink: '/dashboard/price-rule'},
        {label: 'Service Cities', icon: 'pi pi-fw pi-building', routerLink: '/dashboard/service-city'},
        {label: 'Service Areas', icon: 'pi pi-fw pi-map', routerLink: '/dashboard/service-area', separator: true},


        {label: 'Booking Financials',icon: 'pi pi-fw pi-money-bill', routerLink: '/statistic/money', badge: 'new'},
        {label: 'Top Payers',icon: 'pi pi-fw pi-star', routerLink: '/statistic/top-payers', badge: 'new'},
        {label: 'Booking Stats',icon: 'pi pi-fw pi-chart-pie', routerLink: '/dashboard/stats/booking'},
        {label: 'User Stats',icon: 'pi pi-fw pi-chart-bar', routerLink: '/dashboard/stats/user'},
        {label: 'Carer Stats',icon: 'pi pi-fw pi-chart-bar', routerLink: '/dashboard/stats/carer'},
        // {label: 'Admins', icon: 'pi pi-fw pi-sitemap', routerLink: '/dashboard/admin'}, // , badge: 'new'
        // {label: 'Observer', icon: 'pi pi-fw pi-eye', routerLink: '/dashboard/promo-code'},
        // {label: 'Statistic',icon: 'pi pi-fw pi-chart-line', routerLink: '/statistic', badge: 'new',},
        // {label: 'Updates',icon: 'pi pi-fw pi-arrow-circle-up', routerLink: '/dashboard/update', badge: 'new'},
      ]
    },
  ];

  ngOnInit() {

  }

  onKeydown(event: KeyboardEvent) {
    const nodeElement = (<HTMLDivElement>event.target);
    if (event.code === 'Enter' || event.code === 'Space') {
      nodeElement.click();
      event.preventDefault();
    }
  }
}

